export const CALENDAR_LOCALES: any = {
    fr: {
        firstDayOfWeek: 1,
          dayNames: [ "dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi" ],
          dayNamesShort: [ "dim","lun","mar","mer","jeu","ven","sam" ],
          dayNamesMin: [ "D","L","M","M","J","V","S" ],
          monthNames: [ "janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre" ],
          monthNamesShort: [ "jan","fév","mar","avr","mai","jun","jul","aou","sep","oct","nov","dec" ],
          today: 'Aujourd\'hui',
          clear: 'supprimer'
      },
      en: {
        firstDayOfWeek: 1,
        dayNames: [ "sunday","monday","tuesday","wednesday","thursday","friday","saturday" ],
        dayNamesShort: [ "sun","mon","tue","wed","thu","fri","sat" ],
        dayNamesMin: [ "S","M","T","W","T","F","S" ],
        monthNames: [ "january","february","march","april","may","june","july","august","september","october","november","december" ],
        monthNamesShort: [ "jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec" ],
        today: 'Today',
        clear: 'clear'
      },
      nl: {
        firstDayOfWeek: 1,
        dayNames: [ "zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag" ],
        dayNamesShort: [ "zon","maa","din","woe","don","vri","zat" ],
        dayNamesMin: [ "Z","M","D","W","D","V","Z" ],
        monthNames: [ "januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december" ],
        monthNamesShort: [ "jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec" ],
        today: 'Vandaag',
        clear: 'verwijderen'
      },
      es: {
        firstDayOfWeek: 1,
        dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
        dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
        dayNamesMin: [ "D","L","M","X","J","V","S" ],
        monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
        monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
        today: 'Hoy',
        clear: 'Borrar'
    }
}